import { render } from "./BoqConsolidated.vue?vue&type=template&id=284f8165&scoped=true"
import script from "@/assets/boq/BoqConsolidated.js?vue&type=script&lang=js"
export * from "@/assets/boq/BoqConsolidated.js?vue&type=script&lang=js"

import "./BoqConsolidated.vue?vue&type=style&index=0&id=284f8165&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284f8165"]])

export default __exports__